import {
	Component,
	OnInit,
	OnDestroy,
	ViewChildren,
	QueryList,
} from '@angular/core';
import { FormBuilder, FormControlName, FormGroup, Validators } from '@angular/forms';
import { map, takeUntil } from 'rxjs/operators';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormConfig } from 'src/shared/form-models/form-cva.component';
import { preventFlicker } from 'src/shared/utilities/custom-rxjs-operators';
import { CustomerDetailPartialState } from './+state/customer-detail.reducer';
import { Store, select } from '@ngrx/store';
import * as CustomerDetailSelectors from './+state/customer-detail.selectors';
import * as CustomerDetailActions from './+state/customer-detail.actions';
import { touchAllControls } from 'src/shared/utilities/utility-functions';
import { CustomerDetails } from './customer-detail.models';
import { Subject } from 'rxjs';

const customerDetailsFormConfig: FormConfig<CustomerDetails> = {
	generalInfo: [''],
	address: ['', Validators.required],
	documents: [''],
	contacts: [''],
	contractedRates: [''],
};

@Component({
	templateUrl: './customer-detail.component.html',
})
export class CustomerDetailComponent extends SelfDestruct
	implements OnInit, OnDestroy {
	@ViewChildren(FormControlName) childControls: QueryList<FormControlName>;
	private _invalidSubmission = new Subject<number>();

	form = this.fb.group(customerDetailsFormConfig) as FormGroup;

	readonly id$ = this.store.pipe(
		select(CustomerDetailSelectors.getSelectedCustomerId)
	);
	readonly isExistingCustomer$ = this.store.pipe(
		select(CustomerDetailSelectors.getSelectedCustomerId),
		map((id) => id !== 0)
	);

	readonly isLoadingCustomer$ = this.store.pipe(
		select(CustomerDetailSelectors.getLoadingStatus)
	);

	readonly isSaving$ = this.store.pipe(
		select(CustomerDetailSelectors.getIsSaving),
		preventFlicker(1000)
	);

	readonly railroads$ = this.store.pipe(
		select(CustomerDetailSelectors.getRailroads)
	);

	readonly rwics$ = this.store.pipe(select(CustomerDetailSelectors.getRwics));

	readonly jobs$ = this.store.pipe(select(CustomerDetailSelectors.getJobs));

	readonly invalidSubmission$ = this._invalidSubmission.asObservable();

	readonly title$ = this.store.pipe(select(CustomerDetailSelectors.getTitle));

	constructor(
		private readonly store: Store<CustomerDetailPartialState>,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.store
			.pipe(
				select(CustomerDetailSelectors.getSelectedCustomerForm),
				takeUntil(this.destroyed)
			)
			.subscribe((formValue) =>
				this.form.patchValue(formValue, { emitEvent: false })
			);
	}

	save(stay = false) {
		if (this.form.valid) {
			const formValue = this.form.value;
			this.store.dispatch(
				CustomerDetailActions.saveRequested({
					shouldStayOnPage: stay,
					formValue,
				})
			);
		} else {
			touchAllControls(this.childControls);
			this._invalidSubmission.next(new Date().getTime());
		}
	}

	ngOnDestroy() {
		this.store.dispatch(CustomerDetailActions.customerDetailDestroyed());
		super.ngOnDestroy();
	}
}
